(() => {
  const root = document.querySelector('[data-stores]');
  if (!root) return;
  const query = root.querySelector('[data-store-query]');
  const chips = [...root.querySelectorAll('[data-store-filter]')];
  let filter = 'all';

  const apply = () => {
    const q = (query?.value || '').toLowerCase().trim();
    root.querySelectorAll('[data-store-card]').forEach((card) => {
      const hay = card.dataset.search || '';
      const types = card.dataset.types || '';
      const matchesQuery = !q || hay.includes(q);
      const matchesFilter = filter === 'all' || types.includes(filter);
      card.hidden = !(matchesQuery && matchesFilter);
    });
    const visible = [...root.querySelectorAll('[data-store-card]')].filter((c) => !c.hidden);
    const empty = root.querySelector('[data-stores-empty]');
    if (empty) empty.hidden = visible.length > 0;
  };

  query?.addEventListener('input', apply);
  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      filter = chip.dataset.storeFilter;
      chips.forEach((c) => c.classList.toggle('is-selected', c === chip));
      apply();
    });
  });
})();
